import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import api from 'api';
import autobind from 'autobind-decorator';
import { query } from 'redux-bees';
import { withRouter } from 'react-router-dom';
import Tooltip from 'components/Tooltip';

@withRouter

@query('plugins', api.getSiteWpPlugins, (perform, props) => (
  perform({ siteId: props.site.id })
))

export default class Backups extends Component {
  static propTypes = {
    plugins: PropTypes.array,
  }


  @autobind
  renderPlugin(plugin) {
    const rowClass = plugin.attributes.status === 'inactive' || plugin.attributes.compatibility === 'must_be_deactivated' ? 'inactive' : plugin.attributes.compatibility;
    return (
      <div>
        <div className={`Plugins__item Plugins__item--${rowClass}`}>
          <div className="Plugins__item__cell Plugins__item__cell--name">
            {plugin.attributes.name}
          </div>
          <div className="Plugins__item__cell Plugins__item__cell--info">
            {plugin.attributes.description &&
              <Tooltip label={plugin.attributes.description}>
                <i className="icon--info" />
              </Tooltip>
            }
          </div>
          <div className="Plugins__item__cell Plugins__item__cell--version">
            {plugin.attributes.version}
          </div>
          <div className="Plugins__item__cell Plugins__item__cell--status">
            {plugin.attributes.status}
          </div>
          <div className="Plugins__item__cell Plugins__item__cell--compatibility">
            {this.t(`Plugin.${plugin.attributes.compatibility}`)}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { plugins } = this.props;

    return (
      <div>
        <div className="Deploys__bar">
          <div className="Deploys__bar__left">
            Here you can check the compatibility of your WordPress plugins with HardyPress.
            The list is updated every time WordPress is switched ON.
          </div>
        </div>
        { plugins && plugins.length > 0 &&
          <div className="Plugins__list">
            <div className="Plugins__item Plugins__item__header">
              <div className="Plugins__item__cell Plugins__item__cell--name">
                Name
              </div>
              <div className="Plugins__item__cell Plugins__item__cell--info" />
              <div className="Plugins__item__cell Plugins__item__cell--version">
                Version
              </div>
              <div className="Plugins__item__cell Plugins__item__cell--status">
                Status
              </div>
              <div className="Plugins__item__cell Plugins__item__cell--compatibility">
                HP Compatibility
              </div>
            </div>
            {plugins.map(this.renderPlugin)}
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Plugins.jsx